import Typography from '@alltrails/core/components/Typography';
import sanitizeHtml from '@alltrails/core/utils/sanitizeHtml';
import styles from './PageUITextBlock.module.scss';

// What the server's markdown renders that web styles. Anything else, ex: an image or a heading, is dropped, keeping its text.
const sanitizeConfig = { ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'ul', 'ol', 'li', 'a'], OPEN_LINKS_IN_NEW_TAB: true };

type Props = {
  /** HTML from the server, sanitized here before it renders. */
  body: string;
};

/**
 * The agent's answer as formatted text, for `text-block`.
 */
export default function PageUITextBlock({ body }: Props) {
  const __html = sanitizeHtml(body, sanitizeConfig);

  return (
    <Typography component="div" variant="paragraph200">
      <div className={styles.textBlock} dangerouslySetInnerHTML={{ __html }} />
    </Typography>
  );
}
